import type { IconName } from '../../shared/icons/icon.component';
export interface SubMenuItem {
  /** Unique route id (used as a stable @for track key). */
  id?: string;
  label: string;
  route?: string | null;
  active?: boolean;
  hidden?: boolean;
  /** Non-navigable placeholder (e.g. route not wired under Prism yet). */
  disabled?: boolean;
}

export interface MenuItem {
  /** Unique route id (used as a stable @for track key). */
  id?: string;
  icon: IconName;
  label: string;
  route?: string;
  active: boolean;
  expanded?: boolean;
  children?: SubMenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  {
    icon: 'layoutDashboard' as IconName,
    label: 'Dashboard',
    route: '/app/dashboard',
    active: false,
    expanded: false,
    children: [
      // {
      //   label: 'Page Route',
      //   route: 'app/prism/page-routes',
      //   active: false,
      // },
      //     {
      //       label: 'Monthly Reports (Page 2)',
      //       route: '/app/dashboard/monthly-report-2',
      //       active: false,
      //     },
      //     {
      //       label: 'Social Media Performance',
      //       route: '/app/dashboard/social-platforms',
      //       active: false,
      //     },
      //     {
      //       label: 'Lendee Dashboard',
      //       route: '/app/dashboard/lendee-dashboard',
      //       active: false,
      //     },
      //     {
      //       label: 'CoolCredit Dashboard',
      //       route: '/app/dashboard/coolcredit-dashboard',
      //       active: false,
      //     }
      //   ],
      // },
      // {
      //     icon: 'chartNoAxesCombined' as IconName,
      //   label: 'Visionboard',
      //   route: '/app/visionboard',
      //   active: false,
      //   expanded: false,
      //   children: [
      //     {
      //       label: 'Business performance report',
      //       route: '/app/visionboard/business',
      //       active: false,
      //     },
      //     {
      //       label: 'Contracts report',
      //       route: '/app/visionboard/contracts',
      //       active: false,
      //     }
      //   ],
      // },
      // {
      //   icon: 'serverCrash' as IconName,
      //   label: 'Server Matrix',
      //   route: '/app/matrix',
      //   active: false,
      //   expanded: false,
      //   children: [
      //     //  {
      //     //   label: 'Prompt report',
      //     //   route: '/app/prompt/ai',
      //     //   active: false,
      //     // },
      //   ],
      // },
      // {
      //   icon: 'circleDollarSign' as IconName,
      //   label: 'Cron Payments',
      //   route: '/app/cron-payments',
      //   active: false,
      //   expanded: false,
      // }
    ],
  },
];
